"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Edit2 = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 48 48", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "1em", height: "1em" }, props),
    React.createElement("defs", null,
        React.createElement("path", { d: "M6 34.5V42h7.5l22.12-22.12-7.5-7.5L6 34.5zm35.42-20.42c.78-.78.78-2.04 0-2.82l-4.68-4.68c-.78-.78-2.04-.78-2.82 0l-3.66 3.66 7.5 7.5 3.66-3.66z", id: "edit_2_svg__a" })),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M0 0h48v48H0z" }),
        React.createElement("path", { d: "M0 0h48v48H0z" }),
        React.createElement("mask", { id: "edit_2_svg__b", fill: "#fff" },
            React.createElement("use", { xlinkHref: "#edit_2_svg__a" })),
        React.createElement("use", { fill: "currentColor", xlinkHref: "#edit_2_svg__a" }),
        React.createElement("g", { mask: "url(#edit_2_svg__b)", fill: "currentColor" },
            React.createElement("path", { d: "M0 0h48v48H0z" })),
        React.createElement("text", { fontFamily: "HelveticaNeue-Bold, Helvetica Neue", fontSize: 18, fontWeight: "bold", fill: "currentColor" },
            React.createElement("tspan", { x: 32.992, y: 42 }, "2"))))); };
exports.default = Edit2;
//# sourceMappingURL=Edit2.js.map